import { useContext, createContext, useState, useEffect } from 'react';
import useDataUserAccount from './dataHooks/useDataUserAccount';

// Create the context
const gdContext = createContext();

// Create the provider component
export const GlobalDataProvider = ({ children }) => {
  //const [isMobileView, setIsMobileView] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [accountId, setAccountId] = useState();
  const [implementationId, setImplementationId] = useState();
  const [productSelection, setProductSelection] = useState(false);

  const { isLoading, implementation, fetchImplementation } = useDataUserAccount()

  useEffect(() => {
    fetchImplementation()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const { 
      name,
      email,
      accountId,
      implementationId,
      productSelection,
    } = implementation || {}
    setName(name)
    setEmail(email)
    setAccountId(accountId)
    setImplementationId(implementationId)
    setProductSelection(productSelection)
  }, [implementation])

  return (
    <gdContext.Provider value={{
      isLoading,
      //isMobileView,
      //setIsMobileView,
      name,
      setName,
      email,
      setEmail,
      accountId,
      setAccountId,
      implementationId,
      setImplementationId,
      productSelection,
      setProductSelection
    }}>
      {children}
    </gdContext.Provider>
  );
};

/**
 Usage:
 
 import useGlobalDataContext from '../GlobalData'
 const { isMobileView, setIsMobileView } = useGlobalDataContext()
 setIsMobileView(true)
 */
export const useGlobalData = () => useContext(gdContext)